/* tslint:disable */

declare var Object: any;
export interface SFElearningReportInterface {
  "id"?: number;
}

export class SFElearningReport implements SFElearningReportInterface {
  "id": number;
  constructor(data?: SFElearningReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFElearningReport`.
   */
  public static getModelName() {
    return "SFElearningReport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFElearningReport for dynamic purposes.
  **/
  public static factory(data: SFElearningReportInterface): SFElearningReport{
    return new SFElearningReport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFElearningReport',
      plural: 'SFElearningReports',
      path: 'SFElearningReports',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFElearningReport.ts